import React, {useEffect, useState} from 'react';
import PropTypes from "prop-types";
import {CsfPivotalFournisseurRecognitionTab4Table} from "./csf-fournisseur-recognition-details-tab4-table";
import CsfFournisseurPagination from "../includes/csf-fournisseur-pagination";
import {
  CsfPivotalFournisseurFormateurModal
} from "../csf-fournisseur-gestion-formateurs/csf-fournisseur-gestion-formateurs-modal";

export function CsfPivotalFournisseurRecognitionDetailsTab4({trainers, accessToken, apiUrl, apiEnv}) {

  const [startRow, setStartRow] = useState(1);
  const [offset, setOffset] = useState(5);
  const [total, setTotal] = useState(1);
  const [editTrainer, setEditTrainer] = useState('');
  const [slicedFilteredTrainers, setSlicedFilteredTrainers] = useState([]);


  useEffect(() => {
    // Set filtered only after props are received
    setTotal(trainers.length);
    if (trainers && trainers.length > 0) {
      setSlicedFilteredTrainers(trainers.slice((startRow - 1), (startRow + offset) - 1));
    }
  }, [trainers]);

  useEffect(() => {
    setSlicedFilteredTrainers(trainers.slice((startRow - 1), (startRow + offset) - 1));
  }, [startRow]);

  function handleModalClick(Contact_id){
    setEditTrainer(Contact_id);
  }

  return (
      <div className="tab-panel hide" id="trainers-tab" role="tabpanel">

          <CsfPivotalFournisseurRecognitionTab4Table trainers={slicedFilteredTrainers} handleModalClick={handleModalClick}/>
          <div className="pagination-wrapper smaller-wrapper">
            <CsfFournisseurPagination
              startRow={startRow}
              offset={offset}
              total={total}
              setStartRowFunction={setStartRow}
            />
          </div>

        <CsfPivotalFournisseurFormateurModal
          accessToken={accessToken}
          apiUrl={apiUrl}
          apiEnv={apiEnv}
          editTrainer={editTrainer}
          addToList={false}
        />
      </div>
  );
}

CsfPivotalFournisseurRecognitionDetailsTab4.propTypes = {
  trainers: PropTypes.array,
  accessToken: PropTypes.string,
  apiUrl: PropTypes.string,
  apiEnv: PropTypes.string
};
